
import React, { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { AlertTriangle } from 'lucide-react';

interface PaymentFormProps {
  cardNumber: string;
  expiryDate: string;
  cvv: string;
  name: string;
  error: string;
  isProcessing: boolean;
  onCardNumberChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onExpiryDateChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCvvChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const PaymentForm: React.FC<PaymentFormProps> = ({
  cardNumber,
  expiryDate,
  cvv,
  name,
  error,
  isProcessing,
  onCardNumberChange,
  onExpiryDateChange,
  onCvvChange,
  onNameChange,
}) => {
  return (
    <form className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="card-name">Name on Card</Label>
        <Input 
          id="card-name" 
          placeholder="John Smith"
          value={name}
          onChange={onNameChange}
          disabled={isProcessing}
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="card-number">Card Number</Label>
        <Input 
          id="card-number" 
          placeholder="1234 5678 9012 3456"
          value={cardNumber}
          onChange={onCardNumberChange}
          maxLength={19}
          disabled={isProcessing}
        />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="expiry">Expiry Date</Label>
          <Input 
            id="expiry" 
            placeholder="MM/YY"
            value={expiryDate}
            onChange={onExpiryDateChange}
            maxLength={5}
            disabled={isProcessing}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="cvv">CVV</Label>
          <Input 
            id="cvv" 
            placeholder="123"
            value={cvv}
            onChange={onCvvChange}
            maxLength={3}
            disabled={isProcessing}
          />
        </div>
      </div>
      {error && (
        <div className="text-red-500 text-sm flex items-center">
          <AlertTriangle className="h-4 w-4 mr-1" />
          {error}
        </div>
      )}
    </form>
  );
};

export default PaymentForm;
